

export class CostReviewSecurityEnUsRetrofitConsiderations {
  isRetrofitConsiderationsChecked!: boolean;
  reuseSystemComponents!: number;
  existingWiringReused!: number;
}
